<template>
  <div id="app" >
    <v-app >
      <v-app-bar
              color="deep-purple accent-4"
              dense
              dark
              fixed
      >
        <v-app-bar-nav-icon @click="drawer = true" v-if="loggedIn"></v-app-bar-nav-icon>
        <v-toolbar-title>Hyundai Sales Manager</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="loggedIn" small rounded  icon @click="logout" class="mr-4 btnDisconnect"><v-icon>mdi-logout</v-icon></v-btn>
      </v-app-bar>
      <v-navigation-drawer
              v-model="drawer"
              absolute
              temporary
      >

        <v-list-item v-if="loggedIn">
          <v-list-item-avatar>
            <v-icon color="blue darken-3" large>mdi-account</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="text-left" >
              {{ $store.state.user.firstname }} {{ $store.state.user.lastname }}
              <br>
              <span class="caption">{{ $store.state.user.sitename }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense>

          <v-list-item
                  v-for="item in items"
                  :key="item.title"
                  link
                  class="text-left"
                  :to="item.link"
          >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <router-view class="mt-10" />
    </v-app>
  </div>
</template>

<script>
  import { authComputed } from '@/store/helpers.js'
  export default {
    name: 'MenuBar',
    data () {
      return {
        drawer: null,
        items: [
          { title: 'Missions à prendre', icon: 'mdi-account-clock', link: '/ListeNouvelleDemande' },
          { title: 'Votre portefeuille', icon: 'mdi-account-supervisor-outline', link: '/ListeConnectHistory'},
          { title: 'Votre agenda', icon: 'mdi-calendar-multiselect', link: '/ListeConnect' },
          { title: 'Tarifier', icon: 'mdi-cash-100', link: '/ViewTarifier/VP' },
          { title: 'Vos statistiques', icon: 'mdi-cash-100', link: '/Stats' },
        ],
      }
    },
    methods: {
      logout() {
        if(confirm('Etes-vous sûr de vouloir vous déconnecter ?')) {
          this.$store
                  .dispatch('logout',)
                  .then({})
                  .catch(error => {
                    console.log(error)
                  })
        }
      },
      refresh() {
        location.reload()
      }
    },
    computed: {
      ...authComputed,
    }


  }
</script>

<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>
